import { COUNTRIES } from '@constants/countries';
import { FILING_TYPES } from '@constants/filing';

export * from './hasFiscaleCode';
export * from './hasLocalVatNumber';

const { IT, CZ, PL, GB, DE } = COUNTRIES;

const specificCountries = [IT, CZ, PL];
/**
 * Checks if filing is country specific.
 * @deprecated
 * @param {string} country - Country code
 * @returns {boolean}
 */
export const countrySpecificFiling = country => !!specificCountries.find(c => c === country);

/**
 * Checks if filing is Italian quarterly.
 * @deprecated
 * @param {string} country - Country code
 * @param {string} type - Filing type
 * @returns {boolean}
 */
export const isItalianQuarterly = (country, type) => country === IT && type === FILING_TYPES.VAT;

/**
 * Checks if filing is Italian VPMT.
 * @deprecated
 * @param {string} country - Country code
 * @param {string} type - Filing type
 * @returns {boolean}
 */
export const isItalianVPMT = (country, type) => country === IT && type === FILING_TYPES.VPMT;

const differentVatFormats = [PL];
/**
 * Check if filing has different vat format.
 * @deprecated
 * @param {string} country - Country code
 * @returns {boolean}
 */
export const differentVatFormat = country => !!differentVatFormats.find(c => c === country);

const electronicFilingCountries = [GB, DE];
/**
 * Check if filing is electronic filing country.
 * @deprecated
 * @param {string} country - Country code
 * @returns {boolean}
 */
export const electronicFiling = country => !!electronicFilingCountries.find(c => c === country);

const downloadXMLForCountries = [CZ, PL, IT];
/**
 * Checks if filing has xml downloads.
 * @deprecated
 * @param {string} country - Country code
 * @returns {boolean}
 */
export const xmlCountry = country => !!downloadXMLForCountries.find(c => c === country);
